module.exports = __webpack_public_path__ + "static/media/classIcon.2af79b68.png";